import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.attrs.my_sandboxes"))),
      ]),
      _vm._t("default"),
      _c("actions-component", {
        attrs: { class_table: _vm.getClass },
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [
                _c(VBreadcrumbs, {
                  staticClass: "pa-0",
                  attrs: { items: _vm.getBreadcrumbs },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    staticClass: "btn-inca-secondary",
                    attrs: { icon: "" },
                    on: { click: _vm.refreshClick },
                  },
                  [_c(VIcon, [_vm._v("mdi-refresh")])],
                  1
                ),
                _c(
                  VBtn,
                  {
                    staticClass: "ml-1 btn-inca-secondary",
                    attrs: { dense: "", outlined: "" },
                    on: { click: _vm.onEnableFilter },
                  },
                  [
                    _vm.filterEnabled
                      ? _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("mdi-filter-off-outline"),
                        ])
                      : _vm._e(),
                    !_vm.filterEnabled
                      ? _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("mdi-filter-outline"),
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(_vm.$t("botones.boton_filtrar")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClass },
          [
            _c(
              VCard,
              [
                _c(VDataTable, {
                  key: _vm.items_key,
                  staticClass: "text-center table-inca",
                  attrs: {
                    responsive: "",
                    hover: "",
                    items: _vm.items,
                    headers: _vm.headers,
                    loading: _vm.isLoading,
                    search: _vm.search,
                    "hide-default-footer": "",
                    "items-per-page": _vm.pagination.limit,
                    page: _vm.pagination.current,
                  },
                  on: {
                    pagination: function ($event) {
                      _vm.pagination.total = $event.itemsLength
                    },
                    "update:page": function ($event) {
                      return _vm.$set(_vm.pagination, "current", $event)
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.creation_date",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$moment(new Date(item.creation_date))
                                  .format("DD/MM/YYYY")
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.actions",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex justify-center align-center",
                            },
                            [
                              _c(
                                VMenu,
                                {
                                  attrs: { bottom: "", left: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  { attrs: { icon: "" } },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v("mdi-dots-vertical"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    VList,
                                    [
                                      _c(
                                        VListItem,
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOpenDialogUseCase(
                                                item,
                                                _vm.DIALOG_SEE_REPORT_DETAIL
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VListItemIcon,
                                            [
                                              _c(VIcon, [
                                                _vm._v("mdi-file-outline"),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VListItemContent,
                                            [
                                              _c(VListItemTitle, [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "table_ownership_history.actions.see_report"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      item.status_id === 3 &&
                                      item.company_code === "000" &&
                                      _vm.companyCode === "000"
                                        ? _c(
                                            VListItem,
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.exportToAws(
                                                    item,
                                                    _vm.DIALOG_EXPORT_AWS
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VListItemIcon,
                                                [
                                                  _c(VIcon, [
                                                    _vm._v(
                                                      "mdi-rocket-launch-outline"
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VListItemContent,
                                                [
                                                  _c(VListItemTitle, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "table_ownership_history.actions.export_aws"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      item.status_id === 3 ||
                                      item.status_id === 9
                                        ? _c(
                                            VListItem,
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onOpenDialogUseCase(
                                                    item,
                                                    _vm.DIALOG_REGISTER_FILTER
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VListItemIcon,
                                                [
                                                  _c(VIcon, [
                                                    _vm._v("mdi-filter-plus"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VListItemContent,
                                                [
                                                  _c(VListItemTitle, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "table_ownership_history.actions.register_filter"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      item.status_id === 3 ||
                                      item.status_id === 9
                                        ? _c(
                                            VListItem,
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onOpenDialogUseCase(
                                                    item,
                                                    _vm.DIALOG_ADD_SANDBOX_BASES
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VListItemIcon,
                                                [
                                                  _c(VIcon, [
                                                    _vm._v("mdi-plus"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VListItemContent,
                                                [
                                                  _c(VListItemTitle, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "table_ownership_history.actions.add_sandbox_base"
                                                        )
                                                      ) + " "
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      item.company_code === "000" &&
                                      _vm.companyCode === "000" &&
                                      item.status_id !== 1 &&
                                      item.status_id !== 6
                                        ? _c(
                                            VListItem,
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onOpenDialogUseCase(
                                                    item,
                                                    _vm.DIALOG_DESENCRIPTAR_IDSANDBOX
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VListItemIcon,
                                                [
                                                  _c(VIcon, [
                                                    _vm._v(
                                                      "mdi-lock-open-variant"
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VListItemContent,
                                                [
                                                  _c(VListItemTitle, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "table_ownership_history.actions.desencriptar_idsandbox"
                                                        )
                                                      ) + " "
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      item.status_id === 3 ||
                                      item.status_id === 9
                                        ? _c(
                                            VListItem,
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onOpenDialogUseCase(
                                                    item,
                                                    _vm.DIALOG_ADD_INCA_BASE
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VListItemIcon,
                                                [
                                                  _c(VIcon, [
                                                    _vm._v("mdi-database"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VListItemContent,
                                                [
                                                  _c(VListItemTitle, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "table_ownership_history.actions.add_ids"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      item.owner_name === _vm.userEmail &&
                                      (item.status_id === 3 ||
                                        item.status_id === 9)
                                        ? _c(
                                            VListItem,
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onOpenDialogUseCase(
                                                    item,
                                                    _vm.DIALOG_EDIT_USERS
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VListItemIcon,
                                                [
                                                  _c(VIcon, [
                                                    _vm._v("icon-user_add"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VListItemContent,
                                                [
                                                  _c(VListItemTitle, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "table_ownership_history.actions.edit_users"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      item.status_id === 3
                                        ? _c(
                                            VListItem,
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.generateSandboxUrl(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VListItemIcon,
                                                [
                                                  _c(VIcon, [
                                                    _vm._v("mdi-link"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VListItemContent,
                                                [
                                                  _c(VListItemTitle, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "table_ownership_history.actions.go_sandbox"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      item.status_id === 3 ||
                                      item.status_id === 7 ||
                                      item.status_id === 9
                                        ? _c(
                                            VListItem,
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editAttributes(
                                                    item,
                                                    _vm.DIALOG_EDIT_ATTRIBUTES
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                VListItemIcon,
                                                [
                                                  _c(VIcon, [
                                                    _vm._v("mdi-playlist-edit"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                VListItemContent,
                                                [
                                                  _c(VListItemTitle, [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "table_ownership_history.actions.edit_attrs"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        VListItem,
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOpenDialogUseCase(
                                                item,
                                                _vm.DIALOG_EXTEND_VALIDITY
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VListItemIcon,
                                            [
                                              _c(VIcon, [
                                                _vm._v("mdi-calendar-plus"),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VListItemContent,
                                            [
                                              _c(VListItemTitle, [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "table_ownership_history.actions.increase_validity"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VListItem,
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.onOpenDialogCreateAttrGroup(
                                                item,
                                                _vm.DIALOG_CREATE_ATTR_GROUP
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VListItemIcon,
                                            [
                                              _c(VIcon, [
                                                _vm._v(" mdi-folder-plus"),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VListItemContent,
                                            [
                                              _c(VListItemTitle, [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "table_ownership_history.actions.create_attribute_group"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              item.status_id !== 20
                                ? _c(
                                    VBtn,
                                    {
                                      attrs: { icon: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDeleteDialog(item)
                                        },
                                      },
                                    },
                                    [_c(VIcon, [_vm._v("mdi-delete")])],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.status_id",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          item.flag_attribute_alert === "1"
                            ? _c(
                                VTooltip,
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VChip,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      "text-color":
                                                        _vm.getUseCaseStatus(
                                                          item.status_id
                                                        ).textColor,
                                                      color:
                                                        _vm.getUseCaseStatus(
                                                          item.status_id
                                                        ).color,
                                                    },
                                                  },
                                                  "v-chip",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.getUseCaseStatus(
                                                        item.status_id
                                                      ).status
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  VIcon,
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "2px",
                                                    },
                                                    attrs: { small: "" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "mdi-alert-circle-outline"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_c("span", [_vm._v(_vm._s(item.response))])]
                              )
                            : _c(
                                VChip,
                                {
                                  attrs: {
                                    small: "",
                                    "text-color": _vm.getUseCaseStatus(
                                      item.status_id
                                    ).textColor,
                                    color: _vm.getUseCaseStatus(item.status_id)
                                      .color,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getUseCaseStatus(item.status_id)
                                          .status
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.filterEnabled
          ? _c(
              "div",
              {
                staticClass:
                  "order-md-last order-first col-md-3 col-12 pl-md-0 mb-2",
              },
              [
                _c(
                  VCard,
                  [
                    _c(VCardTitle, { staticClass: "pointer" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("titles.search_filters")) + " "
                      ),
                    ]),
                    _c(
                      VCardText,
                      { staticClass: "pa-2 pt-0" },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "12" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    label: _vm.$t(
                                      "attributes.label.use_case_name"
                                    ),
                                    placeholder: _vm.$t(
                                      "attributes.placeholder.use_case"
                                    ),
                                    type: "text",
                                    outlined: "",
                                    dense: "",
                                  },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.onSearch($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.filters.text_filter,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "text_filter", $$v)
                                    },
                                    expression: "filters.text_filter",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "default mr-1",
                                    attrs: { outlined: "" },
                                    on: { click: _vm.onCleanSearch },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                ),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "primary",
                                    on: { click: _vm.onSearch },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              {
                                staticClass: "text-right",
                                attrs: { cols: "12 mt-3" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("attributes.label.total_records")
                                    ) +
                                    ": " +
                                    _vm._s(_vm.totalRecords) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("dialogs-component", {
        ref: _vm.DIALOG_SEE_REPORT_DETAIL,
        attrs: {
          title: _vm.$t("titles.use_case_report"),
          "show-buttons": true,
          width: 1024,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("use-case-detail-component", {
                  attrs: { item: _vm.useCase },
                  on: { update: _vm.closeDialogFromChildren },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_EXPORT_AWS,
        attrs: {
          title: "Confirmación",
          width: 400,
          text: "¿Está seguro de realizar la exportación a AWS?",
          "disable-si-button": !_vm.has_partyid_match,
        },
        on: { onConfirm: _vm.onYesNO },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  { staticClass: "mt-2" },
                  [
                    _c(VCol, { attrs: { cols: "4" } }, [
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "form_attrs_productize_usecase.destination_scheme"
                              )
                            )
                        ),
                      ]),
                    ]),
                    _c(
                      VCol,
                      { attrs: { cols: "8" } },
                      [
                        _c(VAutocomplete, {
                          attrs: {
                            outlined: "",
                            dense: "",
                            items: _vm.aws_schemes,
                            required: "",
                            "return-object": "",
                            rules: _vm.rules.destination_scheme,
                          },
                          model: {
                            value: _vm.selected_aws_scheme,
                            callback: function ($$v) {
                              _vm.selected_aws_scheme = $$v
                            },
                            expression: "selected_aws_scheme",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "12" } },
                      [
                        !_vm.has_partyid_match
                          ? _c(
                              VAlert,
                              {
                                attrs: {
                                  type: "info",
                                  outlined: "",
                                  dense: "",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "attributes.label.has_not_party_match"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_DELETE,
        attrs: {
          title: "Confirmación de Eliminación",
          text: "¿Estás seguro de eliminar este caso de uso?",
          width: 450,
        },
        on: { onConfirm: _vm.handleDeleteConfirm },
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_REGISTER_FILTER,
        attrs: {
          title: _vm.$t("table_ownership_history.actions.register_filter"),
          "show-buttons": "",
          width: 950,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("register-filter-component", {
                  ref: "registerFilterComponent",
                  attrs: { item: _vm.useCase },
                  on: {
                    close: function ($event) {
                      return _vm.onCloseDialog(_vm.DIALOG_REGISTER_FILTER)
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.registerFilterComponent.onSubmit(
                          $event
                        )
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("frases.register")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_ADD_INCA_BASE,
        attrs: {
          title: _vm.$t("titles.add_inca_base"),
          "show-buttons": "",
          width: 850,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("add-base-ids-component", {
                  ref: "addBaseIdComponent",
                  attrs: { "use-case": _vm.useCase },
                  on: { "update:baseID": _vm.onAddINCABases },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.addBaseIdComponent.onSubmit($event)
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("frases.register")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_ADD_SANDBOX_BASES,
        attrs: {
          title: _vm.$t("titles.add_sandbox_base"),
          "show-buttons": "",
          width: 950,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("add-sandbox-base", {
                  ref: "addSandboxBaseComponent",
                  attrs: { "use-case": _vm.useCase },
                  on: { close: _vm.onCloseAddSandboxBase },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.addSandboxBaseComponent.onSubmitEjemplo(
                          $event
                        )
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("common.add")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_DESENCRIPTAR_IDSANDBOX,
        attrs: {
          title: _vm.$t("titles.desencriptar_idsandbox"),
          "show-buttons": "",
          width: 950,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("add-sandbox-base", {
                  ref: "addSandboxBaseComponent",
                  attrs: {
                    "use-case": _vm.useCase,
                    is_read: true,
                    is_convert_idsandbox: true,
                  },
                  on: { close: _vm.onCloseDialogDesencriptarIdsandbox },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.addSandboxBaseComponent.onSubmitEjemplo(
                          $event
                        )
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("common.add")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_EDIT_USERS,
        attrs: { title: _vm.$t("titles.edit_users_sandbox") },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c("edit-users-component", {
                      attrs: { item: _vm.useCase },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_EDIT_ATTRIBUTES,
        attrs: {
          title: _vm.$t("titles.edit_attributes"),
          "show-buttons": false,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c("edit-attributes-component", {
                      attrs: { item: _vm.useCase },
                      on: {
                        close: function ($event) {
                          return _vm.onCloseDialog(_vm.DIALOG_EDIT_ATTRIBUTES)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_EXTEND_VALIDITY,
        attrs: { title: _vm.$t("titles.extend_validity"), width: 900 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c(VCol, { attrs: { cols: "12" } }, [
                      _c(
                        "div",
                        [
                          _c(VSelect, {
                            attrs: {
                              items: _vm.validityOptions,
                              label: "Nueva vigencia",
                              rules: [
                                function (v) {
                                  return !!v || _vm.$t("reglas.period")
                                },
                              ],
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.extendedValidityMonths,
                              callback: function ($$v) {
                                _vm.extendedValidityMonths = $$v
                              },
                              expression: "extendedValidityMonths",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.submitExtendedValidity(_vm.useCase)
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("common.save")) + " "),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_CREATE_ATTR_GROUP,
        attrs: {
          title: _vm.$t("titles.add_attributes"),
          "show-buttons": false,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VRow,
                  [
                    _c("add-attribute-group-component", {
                      attrs: {
                        item: _vm.internalAttributes,
                        "use-case-id": _vm.useCaseId,
                        "last-version-id": _vm.lastVersionId,
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }